document.addEventListener('click', (e) => {
    const sample_button = e.target.closest('.button_add_sample');

    if (!sample_button) return; // Ignore clicks outside .button_add_sample

    const thisButton = sample_button.closest('button');
    thisButton.classList.add('loading');
    thisButton.setAttribute('aria-disabled', true);
    const variant_id = thisButton.getAttribute('data-id');

    // hook into the product.js scripts:
    let product_form = document.querySelector('product-form');
    if (product_form == null) {
        product_form = document.querySelector('product-card');
    }

    let formData = {
        'items': [{
            'id': variant_id,
            'quantity': 1
        }],
        'sections': product_form.getSectionsToRender().map((section) => section.section),
        'sections_url': window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then((response) => response.json())
        .then((response) => {
            // check if that's the limit now, and if so, hide all sample buttons
            let numberOfFreeItemsInCart = 0;
            for (const item of response.items) {
                if (item.sku.charAt(0) === '/' && item.original_price === 0) {
                    numberOfFreeItemsInCart += item.quantity;
                }
            }

            if (numberOfFreeItemsInCart >= 4) {
                document.querySelectorAll('.button_add_sample').forEach((btn) => {
                    btn.style.display = 'none';
                });
            }

            if (response.status) {
                dispatchCustomEvent('product:variant-error', {
                    source: 'product-form',
                    productVariantId: formData.items[0].id,
                    errors: response.description,
                    message: response.message
                });
                if (response.status === 422) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                }
                product_form.handleErrorMessage(response.description);
                return;
            }

            product_form.renderContents(response);

            dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
            });
        })
        .catch((error) => {
            console.error('Error:', error);
        })
        .finally(() => {
            thisButton.classList.remove('loading');
            thisButton.removeAttribute('aria-disabled');
        });
});
